function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("g", {
  "data-name": "Layer 1"
}, React.createElement("path", {
  fill: "none",
  d: "M6.9 82.79h27.61v32.69H6.9z"
}), React.createElement("path", {
  fill: "currentColor",
  d: "M31.07 42.09L28.69 0h-16.2l-2.38 42.09C9.34 57.88 0 56.59 0 79.31v65.06h41.2V79.31c0-22.72-9.36-21.43-10.13-37.22zM16.21 3.93H25l2.15 37.9H14.06zm18.3 111.55H6.9V82.79h27.61z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 41.2 144.37"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/alcopop-bottle.svg";
export { SvgComponent as ReactComponent };